<div class="setTable12" style="width: 100%; padding: 10px; border: 1px dashed rgba(0, 0, 0, 0.3); border-radius: 10px;">
    <div>
        <div fxFlex="100%" fxLayout="column">
            <span class="inputTitle">Container Numbers</span>
            <app-text-field [isMultiline]="true" [isEditable]="true" [(ngModel)]="container_numbers"
                placeholder="Copy paste the container numbers here." [name]="'description'" class="" fxLayout="column"
                (ngModelChange)="filterContainers($event)">
            </app-text-field>
        </div>
    </div>
    <div>
        <ng-container *ngIf="containers?.data?.length">
            <mat-table [dataSource]="containers" matSort style="max-height: 250px; overflow: auto;">
                <ng-container matColumnDef="select">
                    <mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()"> Select All
                        </mat-checkbox>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <div *ngIf="row.dropoff_date == null">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </div>
                        <span class="new" *ngIf="row.dropoff_date != null">Returned</span>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'container_number'">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Container Number</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 ">
                        <span>
                            {{ data.container.container_number }}
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'container_size_type'">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Container Size</mat-header-cell>
                    <mat-cell *matCellDef="let data; let i=index" class="fs-12">
                        <span>
                            {{ data.container.container_size_type }}
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'ownership'">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Ownership</mat-header-cell>
                    <mat-cell *matCellDef="let data; let i=index" class="fs-12 ">
                        <span class="ownershipChip">
                            {{ data.container.ownership }}
                        </span>
                    </mat-cell>
                </ng-container>
                <mat-header-row class="header-row" *matHeaderRowDef="displayColumns; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayColumns;" [class.blur]="update"></mat-row>
            </mat-table>
            <div class="loadingData" [class.d-none]="!update">
                <logzy-gear-loader></logzy-gear-loader>
            </div>
            <ng-container *ngIf="!containers?.data?.length">
                <div class="noData" (mousemove)="onMouseMove($event)">
                    <h1 #title>No Data Found</h1>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!containers?.data?.length">
            <logzy-billu part1="No " part2="Data " part3="here." font="14px"></logzy-billu>
        </ng-container>
        <div class="totalSelected">
            <span>Selected Containers: <span style="color: #f05f25;">&nbsp;{{ selection?.selected.length }}</span></span>
            <span>Total Containers: <span style="color: 404241;">&nbsp;{{ containers?.data.length }} </span></span>
        </div>
    </div>
</div>